import { useState } from "react";

export const useToggle = (initialValue = false): [boolean, () => void, (v: boolean) => void] => {
  const [value, setValue] = useState(initialValue);

  const toggleValue = () => setValue(!value);

  return [value, toggleValue, setValue];
};
